import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { HttpService } from './http.service';
import { Observable, of, Subject } from 'rxjs';

// models
import { IAddProductsResult, IAddProductsTableItem } from '../models/addProductsTableItem';
import {
	IAddProductsPanelFilters,
	IAddProductsPanelParams
} from '../../planogram/planogram-edit/models/addProductsPanelFilters';
import { ISavedPlanogramFilters } from '../../planogram/planogram-edit/models/savedFilters';
import { ITableData } from '../models/table';

const ROOT_URL: string = '/api/v1/master-products/';

@Injectable({
	providedIn: 'root'
})
export class AddProductsService {

	private _savedFilters: ISavedPlanogramFilters;
	addProductsSubject: Subject<number> = new Subject<number>();
	addedEndSubject: Subject<number> = new Subject<number>();

	constructor(
		private http: HttpClient,
		private httpService: HttpService
	) {}

	set filters(value: ISavedPlanogramFilters) {
		this._savedFilters = {
			categories: value.categories || [],
			brands: value.brands || [],
			suppliers: value.suppliers || [],
			markers: value.markers || [],
			assortment_types: value.assortment_types || [],
			product_statuses: value.product_statuses || [],
			hide_options: value.hide_options || [],
			is_master_position: value.is_master_position ?? null,
		};
	}

	get filters(): ISavedPlanogramFilters {
		return this._savedFilters;
	}

	getProducts(
		params: Partial<IAddProductsPanelParams>,
		filters: Partial<IAddProductsPanelFilters>
	): Observable<IAddProductsResult> {
		return this.http.post<IAddProductsResult>(
			'/api/v2/reports/master-product-list/',
			filters,
			{
				params: new HttpParams({
					fromObject: params
				})
			}
		);
	}

	getProductsByValues(values: Array<string>, params: any = {}): Promise<any> {
        const httpParams: HttpParams = new HttpParams({ fromObject: params });
		return this.httpService.getPromise(
			this.http.post(ROOT_URL + 'excel/', { values: values }, { params: httpParams })
		);
	}

	getProductsTable(
		params: Partial<IAddProductsPanelParams>,
		filters: Partial<IAddProductsPanelFilters>
	): Observable<ITableData<IAddProductsTableItem>> {
		return this.http.post<ITableData<IAddProductsTableItem>>(
			'/api/v2/reports/master-product-list/',
			filters,
			{
				params: new HttpParams({
					fromObject: params
				})
			}
		);
	}

	uploadExcel(fileUpload: any, params: any = {}): Promise<any> {
		let file: File = fileUpload;
		let formData: FormData = new FormData();
		formData.append('file', file, file.name);
		const httpParams: HttpParams = new HttpParams({ fromObject: params });

		return this.httpService.getPromise(
			this.http
				.post(ROOT_URL + 'excel/', formData, { params: httpParams })
				.pipe(catchError(() => of({
					results: {
						products: []
					}
				})))
		);
	}
}